import { Button } from '@qodo/design-system';
import { spawn } from 'utils/translations';

const spawnConsent = spawn('billing.move-consent');

interface PaymentActionConsentProps {
  /** User confirmed: reverse the Move (cancel + refund) then go to checkout. */
  onConfirm: () => void;
  loading: boolean;
}

/**
 * Inline consent step shown when the paid Move needs card authentication (3DS):
 * explains the cancel + refund → checkout reversal and asks the user to confirm.
 */
export const PaymentActionConsent = ({
  onConfirm,
  loading,
}: PaymentActionConsentProps) => (
  <div
    data-testid="payment-action-consent"
    className="flex flex-col gap-4 rounded-lg border border-border-interactive-emphasis-active p-6"
  >
    <p className="text-sm text-text-general-neutral-mid">
      {spawnConsent('message')}
    </p>
    <Button size="sm" onClick={onConfirm} loading={loading} disabled={loading}>
      {spawnConsent('confirm')}
    </Button>
  </div>
);
